import qs from 'qs'

export const queryWorkEntryBySlug = (options: QueryBySlugOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  console.log(searchKey, options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields: ['title'],
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        authors: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `work-entries?${query}`
}
